
import "./loader.css";

export default function Loader() {
    return (<>
       <div className="loading">Loading&#8230;</div>

      <div className="content"><h3>!</h3></div>
    </>)

}